import Page from "../framework/page";
import Server from "../server";
import {App} from "../app/app";
import View, {Notification} from "../framework/view";
import template from "../../pugc/talc-page";
import {ROLE_ADMIN, ROLE_USER, Template} from "../misc/types";
import modal from "../misc/modal";
import {windowHashUrl} from "../misc/utils";

export default class TalcPage extends Page {

    static classname = "talc-page";

    private readonly server = Server.instance();

    private app: App;

    private content?: View;

    private sidebar: boolean = true;

    /**
     * Some functions don't need the full page template. This is set from the App when the content is set.
     */
    customTemplate?: Template;

    // --------------------

    constructor(app: App) {
        super(".page", TalcPage.classname);
        this.app = app;

        // Inits...
        modal();
    }

    setContent(content: View) {
        this.content = content;
        content.setParent(this);
    }

    setSidebarVisible(visible: boolean) {
        this.sidebar = visible;
    }

    protected render0(): JQuery<HTMLElement> {

        const data = this.getRenderData();

        const out = this.pug(this.customTemplate || template, data);

        return out;
    }

    getRenderData() {

        let functionLinks : any[] = [];

        const user = this.app.getUser();
        const l = [
            {
                section: "Music",
                name: "About the project",
                url: "/project",
            },
            {
                section: "Music",
                name: "Library",
                url: "/library"
            },
            {
                section: "Music",
                name: "Fake book",
                url: "/fakebook"
            },
            {
                section: "Music",
                name: "Practichord",
                url: "/practichord"
            },
            {
                section: "Account",
                name: "Account",
                url: "/account",
            },
            /*
            {
                section: "Admin",
                name: "Users",
                url: "/users",
                roles: [ ROLE_ADMIN ],
            },

             */
            {
                section: "Admin",
                name: "Reports",
                url: "/reports",
                roles: [ ROLE_ADMIN ],
            },
            {
                section: "Admin",
                name: "Upload",
                url: "/upload",
                roles: [ ROLE_ADMIN ],
            },
            {
                section: "Admin",
                name: "About",
                url: "/about",
                roles: [ ROLE_ADMIN ],
            },
        ];
        functionLinks = [ ...functionLinks, ...l ];
        if (user) {
            functionLinks.push({
                section: "Logout",
                name: "Log out",
                url: "/logout",
                roles: [ user.role as string ]
            });
        } else {
            functionLinks.push({
                section: "Logout",
                name: "Log in",
                url: "/login",
            });
        }
        const data = {
            content: this.content,
            functionLinks: functionLinks,
            user: this.app.getUser(),
            hashUrl: windowHashUrl(),
            sidebar: this.sidebar,
        };

        return data;
    }

    notify(n: Notification) {
        super.notify(n);
        if (n instanceof LogoutNotification) {
            this.app.setUser(undefined);
            this.app.gotoUrl("/login");
        } else if (n instanceof GotoHomeNotification) {
            this.app.gotoUrl("/");
        }
    }

    toggleSidebar() {
        this.elt().find(".sidebar").toggleClass("expanded");
    }
    collapseSidebar() {
        this.elt().find(".sidebar").removeClass("expanded");
    }
}

View.on(
    "." + TalcPage.classname,
    "click",
    ".app-sidebar__toggle",
    function(that: TalcPage, event, elt) {
        event.preventDefault();
        that.toggleSidebar();
    });

View.on(
    "." + TalcPage.classname,
    "click",
    ".app-content",
    function(that: TalcPage, event, elt) {
        that.collapseSidebar();
    });

View.on(
    "." + TalcPage.classname,
    "click",
    ".update-avail",
    function(that: TalcPage, event, elt) {
        window.location.reload();
    });

export class LogoutNotification extends Notification {
    constructor() {
        super("LogoutNotification");
    }
}

export class GotoHomeNotification extends Notification {
    constructor() {
        super("goto-home");
    }
}


